<template>
  <transition enter-active-class="animated fadeIn short" leave-active-class="animated fadeOut short">
    <div class="talToast" v-show="show">
      <div class="alert" :class="[typeClass]">
        {{ text }}
        <button type="button" class="close" @click="close">
          <span>&times;</span>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      text: '',
      type: 'info',
      duration: 2000
    }
  },
  computed: {
    typeClass () {
      return `alert-${this.type}`
    }
  },
  methods: {
    close () {
      this.show = false
    }
  }
}
</script>

<style scoped>
.talToast {
  position: fixed;
  top: 20px;
  left: 50%;
  z-index: 20000;
  min-width: 250px;
  max-width: 600px;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: center;
}

.alert {
  min-width: 250px;
  overflow: hidden;
  padding: 12px 32px 12px 20px;
  position: relative;
  border-radius: 0;
  font-size: 16px;
}

.close {
  font-weight: normal;
  outline: none;
  position: absolute;
  right: 10px;
  top: 11px;
  font-size: 24px;
}
</style>
